<template>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-container>
      <router-link to="/" class="navbar-brand">
        {{ company.trading_name }}
      </router-link>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav right class="ml-auto d-flex align-items-center">
          <router-link
            to="/sales-funnel"
            class="btn btn-secondary btn-sm mr-0 mr-lg-1"
          >
            Funil de vendas
          </router-link>

          <router-link to="/projects" class="nav-link" v-if="isAdmin">
            Projetos
          </router-link>

          <router-link to="/teams" class="nav-link" v-if="isAdmin || isManager">
            Equipes
          </router-link>

          <router-link to="/clients" class="nav-link">
            Clientes
          </router-link>

          <!-- <router-link to="/reports" class="nav-link" v-if="isAdmin">
            Relatórios
          </router-link> -->

          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              {{ fullName }}
            </template>

            <b-dropdown-text>
              <small class="text-muted">{{ this.userType }}</small>
            </b-dropdown-text>

            <b-dropdown-divider></b-dropdown-divider>
            <router-link to="/settings" class="dropdown-item">
              Configurações
            </router-link>
            <b-dropdown-item @click="logout()">Sair</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
    },
  },
};
</script>

<style lang="scss" scoped>
  .navbar {
    border-bottom: 4px solid #910205 !important;
  }

  .router-link-active {
    color: #fff !important;
  }

  .dropdown-menu {
    .router-link-active {
      background: #007bff;
      color: #fff !important;
    }
  }
</style>
